import { isDefined } from '@freelancer/utils';
import { ProjectApi } from 'api-typings/projects/projects';
import { _transformProject } from '../projects';
import { transformSkill } from '../skills';
import { ThreadProject } from './thread-projects.model';

export function transformThreadProject(projectApi: ProjectApi): ThreadProject {
  return {
    ..._transformProject(projectApi),
    skills: isDefined(projectApi.jobs)
      ? projectApi.jobs.map(transformSkill)
      : [],
  };
}
